<script lang="ts">
	import FormWithLabel from "../../molecules/FormWithLabel.svelte";
	import type { RecruitmentService } from "../../services/recruitment.service";

	export let service: RecruitmentService
	export let klass = ''
	const model = service.store.model
	const employmentStatuses = service.store.employmentStatuses
</script>

<div class="{klass}">
	<FormWithLabel
		label="雇用形態"
		input={service.handleEmploymentStatuses}
		values={$model.employmentStatuses}
		inputType="checkboxes"
		options={$employmentStatuses}
	/>
</div>